export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
      return parts.pop().split(';').shift(); // Returns the value of the cookie
    }
    
    return null; // Cookie not found
  }
 
export function  sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

export  function checkCookieForUsername() {
    const username = getCookie('Username');
    if (username) {
      return true;
    } else {
      return false;
    }
  }

export function slugify(courseName: string): string {
  return courseName
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '') // remove special chars
    .replace(/\s+/g, '-')        // replace spaces with hyphens
    .trim();
}
